// node_modules/srraf/dist/srraf.es.js
var n;
var e;
var i;
var o;
var t;
var r;
var f;
var d;
var p;
var u = [];
function w(n2, a) {
  return e = window.pageXOffset, o = window.pageYOffset, r = window.innerHeight, d = window.innerWidth, void 0 === i && (i = e), void 0 === t && (t = o), void 0 === p && (p = d), void 0 === f && (f = r), (a || o !== t || e !== i || r !== f || d !== p) && (!function(n3) {
    for (var w2 = 0; w2 < u.length; w2++) u[w2]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n3);
  }(n2), i = e, t = o, f = r, p = d), requestAnimationFrame(w);
}
function srraf_es_default(e2) {
  return u.indexOf(e2) < 0 && u.push(e2), n = n || w(performance.now()), { update: function() {
    return w(performance.now(), true), this;
  }, destroy: function() {
    u.splice(u.indexOf(e2), 1);
  } };
}

// src/scripts/shared/fluco-shared-video-pair.js
var VideoPair = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      desktopVideo: "video.fluco-video--desktop",
      mobileVideo: "video.fluco-video--mobile"
    };
    this.classes = {};
    this.desktopBreakpoint = 720;
  }
  static observedAttributes = ["data-visible"];
  connectedCallback() {
    this.desktopVideo = this.querySelector(this.selectors.desktopVideo);
    this.mobileVideo = this.querySelector(this.selectors.mobileVideo);
    this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    this.aboveMobile = this.viewportWidth > this.desktopBreakpoint;
    if (this.aboveMobile) {
      if (this.desktopVideo) {
        this.desktopVideo.poster = this.desktopVideo.getAttribute("data-poster");
        const desktopVideoImg = this.desktopVideo.querySelector("img");
        if (desktopVideoImg) {
          desktopVideoImg.src = desktopVideoImg.getAttribute("data-src");
        }
      }
    }
    this.swapToCorrectVideo();
    this.widthWatcher = srraf_es_default(({ vw, pvw }) => {
      if (vw === pvw) return;
      this.viewportWidth = vw;
      const nowAboveMobile = vw > this.desktopBreakpoint;
      if (nowAboveMobile !== this.aboveMobile) {
        this.aboveMobile = nowAboveMobile;
        this.swapToCorrectVideo();
      }
    });
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case "data-visible":
        if (newValue === "true") {
          this.playVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        } else {
          this.pauseVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        }
        break;
    }
  }
  swapToCorrectVideo() {
    if (this.aboveMobile) {
      this.pauseVideo(this.mobileVideo);
      this.loadVideo(this.desktopVideo);
      this.playVideo(this.desktopVideo);
    } else {
      this.pauseVideo(this.desktopVideo);
      this.loadVideo(this.mobileVideo);
      this.playVideo(this.mobileVideo);
    }
  }
  loadVideo(video) {
    if (!video) return;
    video.load();
  }
  playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.play();
  }
  pauseVideo(video) {
    if (!video) return;
    video.pause();
  }
};
if (!customElements.get("fluco-shared-v6-video-pair")) {
  customElements.define("fluco-shared-v6-video-pair", VideoPair);
}
